var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBarometer = function SvgBarometer(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303C42"
    },
    d: "M256,512C114.8,512,0,397.2,0,256S114.8,0,256,0s256,114.8,256,256S397.2,512,256,512z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0",
    style: {
      fill: "#5C6671"
    },
    d: "M256,21.3C126.6,21.3,21.3,126.6,21.3,256S126.6,490.7,256,490.7 S490.7,385.4,490.7,256S385.4,21.3,256,21.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGCleanerId_0_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 43.3045,
    y1: 357.1802,
    x2: 468.6955,
    y2: 158.8198,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0_1_",
    style: {
      fill: "url(#SVGCleanerId_0_3_)"
    },
    d: "M256,21.3C126.6,21.3,21.3,126.6,21.3,256 S126.6,490.7,256,490.7S490.7,385.4,490.7,256S385.4,21.3,256,21.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGCleanerId_0_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 90.125,
    y1: 423.875,
    x2: 421.875,
    y2: 92.125,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0_2_",
    style: {
      fill: "url(#SVGCleanerId_0_4_)"
    },
    d: "M256,21.3C126.6,21.3,21.3,126.6,21.3,256 S126.6,490.7,256,490.7S490.7,385.4,490.7,256S385.4,21.3,256,21.3z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M37.3,272C37.3,142.6,142.6,37.3,272,37.3c60.6,0,115.8,23.3,157.5,61.2 c-43-47.3-104.7-77.2-173.5-77.2C126.6,21.3,21.3,126.6,21.3,256c0,68.8,29.9,130.5,77.2,173.5C60.6,387.8,37.3,332.6,37.3,272z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303C42"
    },
    d: "M256,82.7c-4.418,0-8-3.582-8-8V53.3c0-4.418,3.582-8,8-8s8,3.582,8,8v21.4 C264,79.119,260.418,82.7,256,82.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303C42"
    },
    d: "M165.307,107.001c-2.774,0-5.471-1.445-6.949-4.024l-10.6-18.5 c-2.196-3.833-0.869-8.722,2.964-10.918s8.722-0.869,10.918,2.964l10.6,18.5c2.196,3.833,0.869,8.722-2.964,10.918 C168.023,106.66,166.656,107.001,165.307,107.001z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303C42"
    },
    d: "M98.993,173.301c-1.349,0-2.716-0.341-3.97-1.06l-18.5-10.6c-3.833-2.196-5.161-7.085-2.964-10.919 c2.197-3.833,7.086-5.16,10.918-2.964l18.5,10.6c3.833,2.196,5.161,7.085,2.964,10.919 C104.463,171.856,101.767,173.301,98.993,173.301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303C42"
    },
    d: "M431.492,365.301c-1.349,0-2.715-0.341-3.97-1.06l-18.5-10.6c-3.833-2.196-5.16-7.085-2.964-10.919 c2.195-3.833,7.082-5.162,10.919-2.964l18.5,10.6c3.833,2.196,5.16,7.085,2.964,10.919 C436.964,363.856,434.267,365.301,431.492,365.301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303C42"
    },
    d: "M74.7,264H53.3c-4.418,0-8-3.582-8-8s3.582-8,8-8h21.4c4.418,0,8,3.582,8,8S79.119,264,74.7,264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303C42"
    },
    d: "M458.7,264h-21.4c-4.418,0-8-3.582-8-8s3.582-8,8-8h21.4c4.418,0,8,3.582,8,8S463.118,264,458.7,264 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303C42"
    },
    d: "M80.507,365.301c-2.774,0-5.471-1.444-6.949-4.023c-2.196-3.834-0.869-8.723,2.964-10.919l18.5-10.6 c3.833-2.197,8.722-0.869,10.918,2.964c2.196,3.834,0.869,8.723-2.964,10.919l-18.5,10.6 C83.223,364.96,81.856,365.301,80.507,365.301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303C42"
    },
    d: "M413.008,173.301c-2.774,0-5.471-1.444-6.949-4.023c-2.196-3.834-0.869-8.723,2.964-10.919 l18.5-10.6c3.834-2.198,8.722-0.869,10.919,2.964c2.196,3.834,0.869,8.723-2.964,10.919l-18.5,10.6 C415.724,172.96,414.355,173.301,413.008,173.301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303C42"
    },
    d: "M346.692,107.001c-1.349,0-2.715-0.341-3.97-1.06c-3.833-2.196-5.16-7.085-2.964-10.918l10.6-18.5 c2.196-3.834,7.083-5.162,10.919-2.964c3.833,2.196,5.16,7.085,2.964,10.918l-10.6,18.5 C352.164,105.557,349.467,107.001,346.692,107.001z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303C42"
    },
    d: "M256,426.7c-23.5,0-42.7-19.1-42.7-42.7c0-11.7,4.7-22.6,13.1-30.6l18.9-215.6 c0.5-5.5,5.1-9.7,10.6-9.7c5.5,0,10.1,4.2,10.6,9.7l18.9,215.6c8.4,8,13.1,19,13.1,30.6C298.7,407.5,279.5,426.7,256,426.7z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6F00"
    },
    d: "M256,260.7l-8.7,98.9c-0.3,3-1.8,5.7-4.2,7.5c-5.4,4.1-8.5,10.3-8.5,16.9c0,11.8,9.6,21.3,21.3,21.3 c11.8,0,21.3-9.6,21.3-21.3c0-6.6-3.1-12.8-8.5-16.9c-2.4-1.8-3.9-4.6-4.2-7.5L256,260.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M256,397.3c-10.2,0-18.4-7.4-20.5-17c-0.2,1.3-0.9,2.4-0.9,3.7 c0,11.8,9.6,21.3,21.3,21.3c11.8,0,21.3-9.6,21.3-21.3c0-1.3-0.6-2.4-0.9-3.7C274.4,389.9,266.2,397.3,256,397.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 225.4328,
    y1: 100.3527,
    x2: 225.7128,
    y2: 100.0627,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M225.4,413.6L225.4,413.6l0.3,0.3C225.6,413.9,225.5,413.7,225.4,413.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.45,
    y1: 302.45,
    x2: 407.689,
    y2: 78.211,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "M263.6,131.4c1.6,1.7,2.8,3.9,3,6.4l18.9,215.6c8.4,8,13.1,19,13.1,30.6 c0,23.5-19.1,42.7-42.7,42.7c-11.7,0-22.2-4.7-29.9-12.3l72.3,72.3C378.7,472,444.8,416.2,474.1,342L263.6,131.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.9846,
    y1: 366.189,
    x2: 488.0154,
    y2: 149.811,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    d: "M256,512C114.8,512,0,397.2,0,256S114.8,0,256,0s256,114.8,256,256S397.2,512,256,512z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBarometer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/barometer.1a6c7c59.svg";
export { ForwardRef as ReactComponent };